define('models/modals/select-deal/index',[
    'underscore',
    'models/base/model',
    'models/base/modal',
    'models/base/sync-collection',
    'models/base/sync-collection-model',
    'lib/utils'
], function(
    _, Model, ModalModel, SyncCollection, SyncCollectionModel
) {
    'use strict';

    var GoodsItem = Model.extend({
        defaults: {
            selected: false
        }
    });

    var GoodsItemCollection = SyncCollection.extend({
        model: GoodsItem
    });

    var SelectDealModalContent = SyncCollectionModel.extend({
        urlPath: '/pages/select-deal',
        collectionClass: GoodsItemCollection,
        defaults: {
        },
        urlParams: function() {
            var params = SyncCollectionModel.prototype.urlParams.apply(this, arguments);
            params.tradeId = this.get('tradeId');
            return params;
        },
        parseSubCollection: function(coll, name, data) {
            var items = data[name];
            for (var i=0, li=items.length; i<li; i++) {
                items[i].canEdit = data.canEdit;
            }
            return SyncCollectionModel.prototype.parseSubCollection.apply(this, arguments);
        },
        getSelected: function() {
            return _.map(this.items.where({ selected: true }), function(model) {
                model = model.getAttributes();
                model.canEdit = true;
                return model;
            });
        }
    });

    var SelectDealModalModel = ModalModel.extend({
        defaults: {
            'title': 'Товар',
            'buttons': [
                { caption: 'Отмена', className: '', 'action': 'cancel' },
                { caption: 'Ок', className: 'btn-success', 'action': 'submit' }
            ],
            body: ''
        },
        constructor: function() {
            ModalModel.apply(this, arguments);
            this.content = new SelectDealModalContent();
            var _this = this;
            this.content.on('afterLoad', function() {
                this.set('loaded', true);
                _this.set('title', 'Товар по Т.П. ' + this.get('name'));
            });
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.content.dispose();
            ModalModel.prototype.dispose.apply(this, arguments);
        }
    });

    return SelectDealModalModel;
});
